import { createSelector } from 'redux-bundler';
import errorsExist from 'utils/errorsExist';
import isCorrectHatchIdFormat from 'utils/isCorrectHatchIdFormat';

import { ORGANIZATION_TEAM } from '../../fresh/schema';
import { READ_TEAM_BY_ORGANIZATION } from '../constants';

export const reactReadTeamByOrganization = createSelector(
  'selectIsLoggedIn',
  'selectCurrentOrganizationId',
  'selectFreshOrganizationsKey',
  'selectIsFetchingTeam',
  'selectErrors',
  (
    isLoggedIn,
    currentOrganizationId,
    freshOrganizations,
    isFetchingTeam,
    errors,
  ) => {
    const teamErrors = errorsExist([READ_TEAM_BY_ORGANIZATION], errors);

    if (
      !isLoggedIn ||
      isFetchingTeam ||
      teamErrors ||
      !currentOrganizationId ||
      !isCorrectHatchIdFormat(currentOrganizationId) ||
      freshOrganizations?.[currentOrganizationId]?.[ORGANIZATION_TEAM]
    ) {
      return false;
    }

    return {
      actionCreator: 'doReadTeamByOrganization',
      args: [{ organizationId: currentOrganizationId }],
    };
  },
);
